import { Box, Divider, SystemIcon, Typography } from '@wishket/design-system';

interface ArticleInfoProps {
  time: number;
  date?: string;
  isPopular?: boolean;
}

const ArticleInfo = ({ time, date, isPopular }: ArticleInfoProps) => {
  return (
    <Box
      className="flex flex-wrap items-center gap-2"
      data-testid="contents-info-root"
    >
      <Box className="flex items-center gap-1.5">
        <SystemIcon
          name="medium_wait"
          className="shrink-0 text-w-gray-700"
          testId="article-info--medium-wait"
        />
        <Typography variant="body2" className="text-w-gray-700">
          {time}분
        </Typography>
      </Box>
      {date && (
        <>
          <Divider isVertical className="h-3.5" />
          <Typography variant="body2" className="text-w-gray-700">
            {date}
          </Typography>
        </>
      )}
      {isPopular && (
        <>
          <Divider isVertical className="h-3.5" />
          <Box className="flex items-center gap-1.5">
            <SystemIcon
              name="medium_popular"
              solid
              className="text-w-yellow-500"
              testId="contents-info-popular-icon"
            />
            <Typography variant="body2" className="text-w-gray-700">
              인기
            </Typography>
          </Box>
        </>
      )}
    </Box>
  );
};

export default ArticleInfo;
